import DpAttemptItem from './AttemptItem/DpAttemptItem.i18n.en';
import DpAttemptsReport from './AttemptsReport/DpAttemptsReport.i18n.en';
export default {
  dashboard: {
    page: 'Reports Dashboard Page',
    title: 'Reports',
    searchBar: 'Search in Great Minds',
    pageTitle: '{{curriculum}} Reports | Great Minds Digital',
    empty: 'There are not matching results for the curricula you selected',
    curriculums: {
      em: 'Math',
      emtx: 'Math-TEKS',
      ww: 'English',
      phd: 'Science',
      phdtx: 'Science-TEKS',
      phdpilot: 'Science Pilot',
      geo: 'Geodes'
    }
  },
  ...DpAttemptItem,
  ...DpAttemptsReport
};